function getItemByIndex(array: any[], index: number): any | null {
  if (index >= 0 && index < array.length) {
    return array[index];
  }
  return null;
}

export default getItemByIndex;